import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BaseChartDirective } from 'ng2-charts';
import { BrowserModule } from '@angular/platform-browser';
import { TableModule } from '@openng/optimus-ui/table';

import { SharedModule } from '@shared';
import { AlleleUsageRoutingModule } from './allele-usage-routing.module';
import { AlleleUsageComponent } from './allele-usage.component';

@NgModule({
  imports: [CommonModule, SharedModule, BaseChartDirective, TableModule, AlleleUsageRoutingModule, BrowserModule],
  declarations: [AlleleUsageComponent],
})
export class AlleleUsageModule {}
